import * as Yup from "yup";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";
import { Field, Form, Formik, FormikHelpers } from "formik";

import BaseInput from "../../../../../components/elements/BaseInput";
import Button from "../../../../../components/elements/Button";
import FormFieldError from "../../../../../components/elements/FormFieldError";
import classes from "./Controls.module.scss";

type FormInitialValues = {
  customUrl: string;
};

type CustomUrlModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  handleSave: (url: string) => void;
};

const CustomUrlModal: FC<CustomUrlModalProps> = ({ isOpen, handleClose, handleSave }) => {
  const formInitialValues: FormInitialValues = {
    customUrl: "",
  };

  const validationSchema = Yup.object({
    customUrl: Yup.string()
      .required("Required field.")
      .transform((value) => value.trim())
      .matches(/^(?:https?:\/\/)?(?:www\.)?[\dA-Za-z-]+(?:\.[A-Za-z]{2,})+(?:\/\S*)?$/, "Invalid URL format"),
  });

  const handleSubmit = async (values: FormInitialValues, actions: FormikHelpers<FormInitialValues>) => {
    const { customUrl } = values;
    handleSave(customUrl);
    actions.resetForm();
    handleClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="Enter Custom Url Modal"
      className={classes.modalContainer}
    >
      <Formik
        initialValues={formInitialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        validateOnBlur={false}
      >
        {({ values }) => (
          <>
            <div className={classes.dialogTitle}>
              <Typography variant="h2">Enter Custom URL</Typography>
            </div>
            <Form>
              <DialogContent className={classes.dialogContent}>
                <div className={classes.input}>
                  <Field
                    as={BaseInput}
                    value={values.customUrl}
                    name="customUrl"
                    variant="outlined"
                    label="Enter a custom URL... *"
                  />

                  <FormFieldError name="customUrl" />
                </div>
              </DialogContent>

              <DialogActions>
                <Button onClick={handleClose} variant="outlined">
                  Cancel
                </Button>
                <Button type="submit">Save Custom URL</Button>
              </DialogActions>
            </Form>
          </>
        )}
      </Formik>
    </Dialog>
  );
};

export default CustomUrlModal;
